import { useNavigate } from "react-router-dom";

export default function WorkingInPNGPage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="pg-hdr">
        <h1>Working in Papua New Guinea</h1>
        <p>General guidance on labour law, work permits and visas for Korean nationals working on the Papua LNG Project.</p>
      </div>

      <section className="sec">
        <div className="container">
          <div className="disclaimer" style={{ marginBottom: "2.5rem" }}>
            ⚠️ This page is general information only, not legal advice. Requirements
            change and depend on your specific role, employer and length of stay.
            Always verify current requirements with PNG's Immigration &amp;
            Citizenship Authority (ICA) and the Department of Labour &amp;
            Industrial Relations, or your employer's HR/mobility team, before
            travelling.
          </div>

          <div className="grid2">
            <div className="info-card">
              <h3>🛂 Work Permits</h3>
              <p>Foreign nationals generally need a PNG work permit before starting paid employment, obtained under the Employment of Non-Citizens Act. In practice:</p>
              <ul>
                <li>Your PNG-based employer (or the contractor/subcontractor engaging you) applies for the work permit on your behalf.</li>
                <li>Work permits are usually tied to a specific employer, role and location.</li>
                <li>Positions are generally expected to be filled by PNG citizens first where suitably qualified local labour is available — a "localisation" principle common across PNG's major resource projects.</li>
                <li>Processing can take several weeks, so early engagement with your employer's mobility process matters.</li>
              </ul>
            </div>
            <div className="info-card">
              <h3>📇 Entry Visas</h3>
              <p>Separate from the work permit, you'll need the correct PNG entry visa:</p>
              <ul>
                <li><strong>Employment/Work Visa</strong> — for those taking up confirmed employment, usually requires an approved work permit first.</li>
                <li><strong>Business Visa</strong> — for short business trips (site visits, negotiations, due diligence) without taking up local employment.</li>
                <li>Visa applications are typically lodged through a PNG diplomatic mission or online through PNG's immigration systems, and commonly require your passport, employment contract, work permit approval and sponsor company documentation.</li>
              </ul>
            </div>
          </div>

          <div className="grid2" style={{ marginTop: "1.75rem" }}>
            <div className="info-card">
              <h3>📋 Typical Documents Needed</h3>
              <ul>
                <li>Valid passport (usually 6+ months validity)</li>
                <li>Signed employment contract or letter of offer</li>
                <li>CV / qualifications / trade certifications</li>
                <li>Police clearance certificate</li>
                <li>Medical clearance (project/employer dependent)</li>
                <li>Passport photos</li>
              </ul>
            </div>
            <div className="info-card">
              <h3>🏗️ On a Project Like Papua LNG</h3>
              <p>
                Large EPC projects like this one typically run structured mobilisation
                programmes through their contractors and subcontractors — meaning much
                of the work permit and visa process is coordinated by your employer
                once you have an offer. Registering early through this portal helps
                connect you with the right employer or subcontractor in the Korean
                logistics and construction chain.
              </p>
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: "3rem" }}>
            <button className="btn-g" onClick={() => navigate("/apply/visa")}>Start an Employment Visa Request →</button>
          </div>
        </div>
      </section>
    </>
  );
}
